<header class="border-b border-gray-200 bg-white">
  <div class="flex h-[4.5rem] items-center justify-between gap-3 px-6 lg:px-8">
    <div class="flex min-w-0 items-center gap-3">
      @if (showMenuButton) {
        <button
          type="button"
          class="flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-700 transition hover:border-brand-primary hover:text-brand-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/30 lg:hidden"
          aria-label="Open navigation menu"
          (click)="onMenuClick()"
        >
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
              d="M4 6H16M4 10H16M4 14H16"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </button>
      }

      <div class="min-w-0">
        @if (headerState.title()) {
          <div class="flex flex-wrap items-center gap-2">
            <h1 class="truncate text-base font-semibold leading-tight tracking-wide text-text-primary md:text-lg">{{ headerState.title() }}</h1>
          </div>
          <p class="mt-0.5 truncate text-xs leading-tight text-[#616161] xl:text-sm">{{ headerState.subtitle() }}</p>
        } @else {
          <div class="flex flex-wrap items-center gap-2">
            <h1 class="truncate text-base font-semibold leading-tight tracking-wide text-text-primary md:text-lg">{{ greeting }}, Dr. {{ userProfile()?.name || displayName }}</h1>
            <span aria-hidden="true" class="text-lg">👋</span>
          </div>
          <p class="mt-0.5 truncate text-xs leading-tight text-[#616161] xl:text-sm">{{ subtitle }}</p>
        }
      </div>
    </div>

    <div class="flex shrink-0 items-center gap-2 sm:gap-3 relative">
      <!-- <button
        type="button"
        class="flex h-10 w-10 items-center justify-center rounded-full text-brand-primary transition hover:bg-brand-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/30"
        aria-label="View notifications"
      >
        <img [src]="imageEnum.BELL_ICON" alt="bell.svg" />
      </button> -->

      <div class="relative">
        <button
          type="button"
          class="my-1 ml-2 flex items-center gap-3 rounded-full bg-[#EAEDFF] p-1.5 transition hover:bg-[#dfe3ff] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/30"
          (click)="toggleProfileDropdown($event)"
        >
          <div
            class="flex h-[2.35rem] w-[2.35rem] shrink-0 items-center justify-center overflow-hidden rounded-full bg-white text-brand-primary"
          >
            <svg viewBox="0 0 24 24" fill="none" class="h-5 w-5" aria-hidden="true">
              <path d="M11 2v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5 2v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M8 15a6 6 0 0 0 12 0v-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <circle cx="20" cy="10" r="2" stroke="currentColor" stroke-width="2" />
            </svg>
          </div>

          <div class="mr-1 hidden flex-col items-start justify-center text-left md:flex">
            <span class="text-[15px] font-bold leading-tight text-[#0F172A]">{{ userProfile()?.name || displayName }}</span>
            <span class="text-[13px] leading-tight text-brand-primary">Doctor</span>
          </div>

          <span
            role="button"
            aria-label="Log out"
            title="Log out"
            class="flex h-[2.35rem] w-[2.35rem] shrink-0 cursor-pointer items-center justify-center rounded-full bg-daily-reports shadow-sm transition-opacity hover:opacity-90"
            (click)="openLogoutModal($event)"
          >
            <img [src]="imageEnum.LOGOUT_ICON" alt="" class="h-[1.1rem] w-[1.1rem]" />
          </span>
        </button>

        @if (isProfileDropdownOpen) {
          <!-- Transparent backdrop to close dropdown when clicking outside -->
          <div class="fixed inset-0 z-40" (click)="closeProfileDropdown()"></div>

          <!-- Dropdown Popup -->
          <div class="absolute right-0 top-full z-50 mt-2 w-80 origin-top-right rounded-2xl bg-white p-4 shadow-lg ring-1 ring-black/5 focus:outline-none" (click)="$event.stopPropagation()">
            <div class="flex items-center gap-3 pb-4">
              <div class="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#EAEDFF] text-brand-primary">
                <svg viewBox="0 0 24 24" fill="none" class="h-8 w-8" aria-hidden="true">
                  <path d="M11 2v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5 2v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M8 15a6 6 0 0 0 12 0v-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <circle cx="20" cy="10" r="2" stroke="currentColor" stroke-width="2" />
                </svg>
              </div>
              <div class="min-w-0">
                <p class="truncate text-base font-semibold text-text-primary">{{ userProfile()?.name || 'Dr. ' + displayName }}</p>
                <span class="mt-1 inline-flex items-center rounded-full bg-brand-primary/10 px-2.5 py-0.5 text-2xs font-semibold text-brand-primary">
                  Doctor
                </span>
              </div>
            </div>

            <div class="flex flex-col divide-y divide-slate-100 border-t border-slate-100">
              <div class="flex items-center gap-3 py-3">
                <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-50">
                  <img [src]="imageEnum.MAIL_ICON" alt="mail.svg" class="h-4 w-4" />
                </div>
                <div class="min-w-0">
                  <p class="text-2xs font-semibold uppercase tracking-wider text-text-secondary">Email</p>
                  <p class="truncate text-sm font-medium text-text-primary">{{ userProfile()?.email || 'N/A' }}</p>
                </div>
              </div>

              <div class="flex items-center gap-3 py-3">
                <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-50">
                  <svg viewBox="0 0 24 24" fill="none" class="h-4 w-4 text-text-secondary" aria-hidden="true">
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="min-w-0">
                  <p class="text-2xs font-semibold uppercase tracking-wider text-text-secondary">Mobile Number</p>
                  <p class="truncate text-sm font-medium text-text-primary">{{ userProfile()?.mobile_number || 'N/A' }}</p>
                </div>
              </div>

              <div class="flex items-center gap-3 py-3">
                <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-50">
                  <svg viewBox="0 0 24 24" fill="none" class="h-4 w-4 text-text-secondary" aria-hidden="true">
                    <path
                      d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6M9 11h.01M15 11h.01M9 15h.01M15 15h.01"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="min-w-0">
                  <p class="text-2xs font-semibold uppercase tracking-wider text-text-secondary">College</p>
                  <p class="text-sm font-medium leading-5 text-text-primary">{{ userProfile()?.college_name || 'N/A' }}</p>
                </div>
              </div>

              <div class="flex items-center gap-3 py-3">
                <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-50">
                  <img [src]="imageEnum.CALENDAR_ICON" alt="calendar.svg" class="h-4 w-4" />
                </div>
                <div class="min-w-0">
                  <p class="text-2xs font-semibold uppercase tracking-wider text-text-secondary">Year</p>
                  <p class="truncate text-sm font-medium text-text-primary">{{ userProfile()?.year_name || 'N/A' }}</p>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</header>

@if (isLogoutModalOpen) {
  <div
    class="logout-modal-backdrop fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/30 px-4"
    (click)="closeLogoutModal()"
    aria-modal="true"
    role="dialog"
    aria-labelledby="logout-modal-title"
  >
    <div
      class="logout-modal-card w-full max-w-[28rem] rounded-[1.75rem] bg-white px-6 pb-7 pt-5 shadow-[0_28px_80px_rgba(28,37,74,0.18)] sm:px-7"
      (click)="$event.stopPropagation()"
    >
      <div
        class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-primary"
      >
        <img [src]="imageEnum.LOGOUT_ICON" alt="" class="h-6 w-6" />
      </div>

      <div class="mt-3 text-center">
        <h2 id="logout-modal-title" class="sub-heading font-semibold">
          Log Out?
        </h2>
        <p class="paragraph mt-2">Are you sure you want to Log out?</p>
      </div>

      <div class="mt-8 flex flex-col gap-3 sm:flex-row">
        <div class="w-1/2">
        <app-outline-button
          text="Cancel"
          ariaLabel="Cancel"
          buttonClass="h-10 w-full text-base hover:bg-brand-primary/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary active:opacity-90"
          (buttonClick)="closeLogoutModal()"
        />
        </div>
        <div class="w-1/2">
        <app-primary-button
          type="button"
          text="Logout"
          buttonClass="w-full text-sm font-medium h-10"
          ariaLabel="Logout"
          (buttonClick)="confirmLogOut()"
        />
        </div>
      </div>
    </div>
  </div>
}
